import { booleanAttribute, Component, EventEmitter, HostBinding, input, Input, OnDestroy, OnInit, output, Output, ViewChild, viewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { distinctUntilChanged, skip, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'nw-date-time-select',
  templateUrl: './date-time-select.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    input:disabled {
      opacity: 0.6 !important;
    }

    .p-datepicker-trigger {
      color: var(--blackColor);
      background-color: #14b8a6 !important;
    }
  `],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: DateTimeSelectComponent, multi: true }
  ]
})
export class DateTimeSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @HostBinding('attr.disabled')
  isDisabled = false;
  @HostBinding('attr.readonly')
  isReadonly?: any;
  @HostBinding('attr.inputId')
  inputId?: any;

  isLocalTime = input(false, { transform: booleanAttribute });
  ignoreTimePart = input(false, { transform: booleanAttribute });

  complete = output();


  config: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'YYYY-MM-DD',
  };

  onChangeFn = (value: any) => { }
  onTouchedFn = () => { }
  value$ = new Subject<DateTime | null>();
  destroy$ = new Subject<void>()

  value?: Date;
  writingValue = false;

  ngOnInit(): void {
    this.value$.pipe(
      skip(1),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(value => {
      if (this.writingValue) {
        this.writingValue = false;
        return;
      }
      this.onChangeFn(value);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  writeValue(obj: any): void {
    this.writingValue = true;
    setTimeout(() => {
      if (obj instanceof DateTime) {
        this.value = obj.toJSDate();
      } else this.value = obj;
    }, 0);

  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onChangeValue(event?: Date) {
    let emitValue: DateTime | null = null;
    if (event) {
      var date = DateTime.fromJSDate(event);
      if (this.isLocalTime()) {
        date = date.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
      }
      if (this.ignoreTimePart()) {
        date = date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      }
      emitValue = date;
    }
    this.value$.next(emitValue);
  }

  handleInput(_event: Event) {
    const event = _event as KeyboardEvent;
    const inputElem = <HTMLInputElement>(event.target);
    const str = inputElem.value;
    let regex = /([0-9]{4})([0-9]{1})/;
    if (regex.test(str)) {
      inputElem.value = str.replace(regex, '$1-$2');
      return;
    }
    regex = /([0-9]{4}-[0-9]{2})([0-9]{1})/;
    if (regex.test(str)) {
      inputElem.value = str.replace(regex, '$1-$2');
      return;
    }
    regex = /[0-9]{4}-[0-9]{2}-[0-9]{2}/;
    if (regex.test(str)) {
      if (DateTime.fromFormat(str, 'yyyy-LL-dd').isValid) {
        this.complete.emit();
      }
    }
  }

}
